
    var riot = require('riot')
    import context from 'static/script/app/ui/checkout2/context/context';
riot.tag2('checkout-payment', '<div class="co-panel"> <h2>Betala med</h2> <div class="co-content"> <invoice-payment if="{opts.model.isInvoicePaymentEnabled}" model="{opts.model}"></invoice-payment> <swish-handel-payment if="{opts.model.isSwishHandelEnabled}" model="{opts.model}"></swish-handel-payment> <braintree-payment model="{opts.model.braintreeCheckoutViewModel}"></braintree-payment> <div class="co-radio-new {co-radio-selected:model.selectedPaymentType === paymentProviderName}" onclick="{selectPaymentType(paymentProviderName)}" each="{model.paymentProviders}"> <div class="header"> <div class="cell"> <div class="checkmark"></div> </div> <div class="cell"> <img riot-src="/static/images/shipping/{logoUrl}" alt="{displayText}"> </div> <div class="cell"> {paymentProviderName} </div> </div> </div> </div> </div>', '', '', function(opts) {
        this.context = context;
        this.model = opts.model;

        this.on('mount', function () {

            if (this.model.preselectedPaymentType) {
                this.context.observable.trigger('payment-type-selected', this.model.preselectedPaymentType);
            }
        });

        this.context.observable.on('payment-type-selected', function (type) {
            this.model.selectedPaymentType = type;
            this.update();
        }.bind(this));

        this.selectPaymentType = function (type) {
            return function () {
                this.context.observable.trigger('payment-type-selected', type);
            }
        }
});
    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/checkout-payment.riot.html